import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a3968bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center bg-background z-50"
}
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/logo.png",
  alt: "Loading",
  class: "w-40 h-40 mx-auto mb-8"
}, null, -1))
const _hoisted_4 = { class: "flex justify-center" }
const _hoisted_5 = {
  key: 1,
  class: "loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bouncing_dots_icon = _resolveComponent("bouncing-dots-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isInitialLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_bouncing_dots_icon)
            ])
          ])
        ]))
      : (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_bouncing_dots_icon)
          ]))
        : _createCommentVNode("", true)
  ]))
}